import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type BridgedChatMessage = {
  role: "user" | "bot";
  text: string;
};

interface ChatBridgeState {
  pendingMessages: BridgedChatMessage[];
}

const initialState: ChatBridgeState = {
  pendingMessages: [],
};

const chatBridgeSlice = createSlice({
  name: "chatBridge",
  initialState,
  reducers: {
    pushChatMessage(state, action: PayloadAction<BridgedChatMessage>) {
      state.pendingMessages.push(action.payload);
    },
    clearChatMessages(state) {
      state.pendingMessages = [];
    },
  },
});

export const { pushChatMessage, clearChatMessages } =
  chatBridgeSlice.actions;

export default chatBridgeSlice.reducer;
